import * as React from "react";

import { Portal } from "../../Common";

export const PortalToPaymentPageBelowSection: React.FunctionComponent = (
  props
) => {
  return (
    <Portal selector=".legacy-magento-checkout-container > .legacy-magento-checkout-container--portal-below">
      {props.children || []}
    </Portal>
  );
};
